import React from 'react'
import { motion } from 'framer-motion'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import 'swiper/css'
import 'swiper/css/navigation'

const ShopByConcernUpdated = () => {
  const concerns = [
    {
      name: "Acne Control",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuD71ioS518oKEMC6OCTfEIvsYtQdCbWO_RPSz4d5niRbGu4n0pS7W-QOhOXFMp0oSnRxuz08rWCtWWE9GH2rp_AOBD_3T5hS3Z6m-gC57gNokbBNrXuI4yCI98IdH-4X63v9f1RVQ6frmLMYLEdU7uGgP8yrpYECHjD14nGuBJR_9d_AD559S4_Cd4Yjotoo7M3Mu_tsJ5t54MCt1dSVzEMBk0Vg2sNXXc1lxflRDBKY9WG9VNLU8tOmQm1ZYHIeS0slXHEyjTNuI8"
    },
    {
      name: "Anti-Aging",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuCq4LlFG-EGhoHfC06tZoxP-BKQK3vAvnJmmbzodclBUackTzIpVql0ytl_ziY6F-JR8_mt8qHxvboRNMOfZ-bt7D6OSNs-TwsKJB1P7qL4D1NtIgE4dIzBmJzvKXX0lGDlR99XwyBteYCTtpJwhT62LIQMOhHsixzgpBnYlQV4OaqKhMclvZMdRu8-Ph7ytBhRa48xpk2I8tFL53Zx_RB4dFNDR0ms3IcfezZtbmo72v3sDV0ALhcBuXQElkXTyI7c5dPcLWquFkI"
    },
    {
      name: "Dullness",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBpFjuL4PWtaeEtkBqroII1SxFTE_IvRvXWIx-VDmnXqIWbRlGAmZ5MKG4YRD0rdoQ0nD5pERNJtzvbUpNQR3DQaej-YJuKMYRxNxXI8IyDBJL1aBjQF6yuKbykpqru7quzbBnCoPIqrpZuxWhvNusbaxnXlNq73bTPnZFFa4rVPo-Ydtk6BTl79VAh71vsHWwEyRdEYZUlXCBFWdZ2uGDJLe1wDsprm21Hu51ITtwvf_x44LEXNUcyWzyGJHOCBRm9ZxGfNXVyB7M"
    },
    {
      name: "Hair Fall",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuB6AkTL1MsdUBh32TZAE9OSXPcT21feCM1-jU0citB4F__DkTQzLovr5uEDYdomwDBqdjExKJdAtT-bLxStZh8Drw2PF_6BTZaA6NZzBSqV6hr_psCfmNOoIcHbDpwOxlQ3p1MQIK36KJrFDv_g24mzgKuf-Q73hy7ealUQ51nCq082Ha_zUc1ptKubr_uHFuNjhsXtibjIyutjgpIIxLIgHDJRNP0OVe9iXy9yw16pDgKu_sXWCuV_fmv8RROLcuLkiVKMqctqvww"
    },
    {
      name: "Dehydration",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuArYat7wIMrxPYSYKg3SHBtVZQ9t1z4F44JiYEoeSv4tcWaUEW9l13mfoGaAJZIpQI0vUuOx259A0cjGnh8qJs_ZWpyddastRnSY-8O_0zPJpF9-Y8cS9y4hcgNWPL9aKkTePmozKDYptUU_3smCC3-tR2f1bktqzRJWQ19TwbxYenjGS04ZyGB56sktGGTywpivX4W90R3lDbkapqll2hLWxK2zDaPT1u_Kba6hUQH1iLg77fewJEH_OnFUKYBQyWs0qamsYp91cU"
    }
  ]

  return (
    <section className="py-24 bg-background-light dark:bg-background-dark overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 mb-16 flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-display mb-4">Shop by Concern</h2>
          <p className="text-slate-500 max-w-md">Targeted solutions for your unique beauty needs, from root to tip.</p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          className="flex space-x-4"
        >
          <button className="concern-prev w-12 h-12 rounded-full border border-slate-200 dark:border-slate-700 flex items-center justify-center hover:bg-primary hover:text-white transition-all">
            <FaArrowLeft />
          </button>
          <button className="concern-next w-12 h-12 rounded-full border border-slate-200 dark:border-slate-700 flex items-center justify-center hover:bg-primary hover:text-white transition-all">
            <FaArrowRight />
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <Swiper
          modules={[Navigation]}
          spaceBetween={24}
          slidesPerView="auto"
          navigation={{
            prevEl: '.concern-prev',
            nextEl: '.concern-next',
          }}
          breakpoints={{
            320: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 24,
            },
          }}
          className="px-4 md:px-24"
        >
          {concerns.map((concern, index) => (
            <SwiperSlide key={concern.name} className="!w-64">
              <motion.a
                href="#"
                className="block relative rounded-2xl overflow-hidden w-64 h-[360px] group"
                whileHover={{ y: -5 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <motion.img
                  alt={concern.name}
                  className="w-full h-full object-cover transition-transform duration-700"
                  src={concern.image}
                  whileHover={{ scale: 1.1 }}
                />
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex flex-col items-center justify-end pb-12 text-white">
                  <h4 className="font-display text-3xl mb-3">{concern.name}</h4>
                  <motion.span
                    initial={{ opacity: 0, y: 20 }}
                    whileHover={{ opacity: 1, y: 0 }}
                    className="bg-white/10 backdrop-blur-md px-6 py-2 rounded-full text-xs uppercase tracking-widest border border-white/20 opacity-0 group-hover:opacity-100 transition-all duration-300"
                  >
                    View Rituals
                  </motion.span>
                </div>
              </motion.a>
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
    </section>
  )
}

export default ShopByConcernUpdated